import { updateVehicleHasProvinceRequest } from "../../data/vehicleHasProvinceApi";
import { validateVehicleHasProvincePayload } from "../validator/validateVehicleHasProvincePayload";

export async function updateVehicleHasProvinceUseCase(payload) {
  const error = validateVehicleHasProvincePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateVehicleHasProvinceRequest(payload);
}
